module.exports = __webpack_public_path__ + "static/media/img6.6bce088c.jpeg";